export default "__VITE_ASSET__9412456f__"